"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setErrors = exports.clearErrorsForValidator = exports.clearErrors = void 0;
const service_1 = require("./service");
/**
 * Remove all errors from the store.
 */
function clearErrors() {
    service_1.errorStoreService.clearErrors();
}
exports.clearErrors = clearErrors;
/**
 * Remove all errors for a specific field in an entity, through a validator.
 */
function clearErrorsForValidator(validator) {
    service_1.errorStoreService.clearErrorsForValidator(validator);
}
exports.clearErrorsForValidator = clearErrorsForValidator;
/**
 * In one go set all error for all entities and their field.
 *
 * @param errors
 */
function setErrors(errors) {
    service_1.errorStoreService.setErrors(errors);
}
exports.setErrors = setErrors;
